import { useCallback, useState } from "react";
import {
  changeSignInMethod,
  verifySignInChangePassword,
} from "@/features/user-settings/infrastructure/api/userSettingsApi";
import type { OtpPreference } from "../../domain/constants/otpConstants";
import { requireAccessToken } from "./useStepUpVerification";

/**
 * Changing the sign-in method: check the current password, re-verify with
 * useStepUpVerification(CHANGE_OTP_PREFERENCE), then save with that temp
 * token. The API checks the password again on save.
 */
export const useSignInMethodChange = () => {
  const [loading, setLoading] = useState(false);

  const run = useCallback(async (action: () => Promise<void>) => {
    setLoading(true);
    try {
      await action();
    } finally {
      setLoading(false);
    }
  }, []);

  const verifyCurrentPassword = useCallback(
    (currentPassword: string) =>
      run(() => verifySignInChangePassword(requireAccessToken(), currentPassword)),
    [run],
  );

  const saveSignInMethod = useCallback(
    (tempAccessToken: string, method: OtpPreference, currentPassword: string) =>
      run(() => changeSignInMethod(tempAccessToken, method, currentPassword)),
    [run],
  );

  return { verifyCurrentPassword, saveSignInMethod, loading };
};
